// extracted by mini-css-extract-plugin
export default {"price":"i9-z","onSale":"j9-z","msrpLabelPrice":"k9-z","msrpLabel":"l9-z","originalPrice":"m9-z","percentOff":"n9-z"};